module.exports = __webpack_public_path__ + "static/media/ic-chevron-down-white.8d80190c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-chevron-down-white.svg
// module id = 651
// module chunks = 0